import { startZohoCrmIntegrationDemoStreamLoop } from './zohoCrmIntegrationDemoStreamLoop.js'

/**
 * @typedef {{
 *   tid: string,
 *   pendingId: string,
 *   signal: AbortSignal,
 *   session: ReturnType<import('../streamSession.js').createAssistantStreamSession>,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 * }} ZohoStreamCtx
 */

/** @param {ZohoStreamCtx} ctx */
export function runZohoCrmIntegrationDemoStream(ctx) {
  startZohoCrmIntegrationDemoStreamLoop(ctx)
}
